import { connect } from 'react-redux'

import { ConnectedRouteTile } from '../../../../integrations/routes'
import { highlightRoute, unhighlightRoute } from '../../actions'

const mapDispatchToProps = (dispatch, { routeId }) => ({
    onMouseEnter: () => dispatch(highlightRoute(routeId)),
    onMouseLeave: () => dispatch(unhighlightRoute()),
})

export default connect(null, mapDispatchToProps)(ConnectedRouteTile)
